import { ListRow, Shimmer } from '@betterment/samba-react';

const TEXT_SHORT_LENGTH = 88;
const TEXT_LONG_LENGTH = 176;

export function ListRowLoader() {
  return (
    <ListRow>
      <ListRow.LeadingAsset>
        <Shimmer css={{ height: 'size.600', width: 'size.600', borderRadius: '8px' }} />
      </ListRow.LeadingAsset>
      <ListRow.LeadingContent css={{ gap: 'space.100' }}>
        <Shimmer css={{ height: '14px', width: TEXT_LONG_LENGTH }} />
        <Shimmer css={{ height: '14px', width: TEXT_SHORT_LENGTH }} />
      </ListRow.LeadingContent>
      <ListRow.TrailingContent>
        <Shimmer css={{ height: '14px', width: TEXT_SHORT_LENGTH }} />
      </ListRow.TrailingContent>
    </ListRow>
  );
}
